import useThemeMode from '@/hooks/useThemeMode';
import { StyledProp } from '@/styled';

interface LogoProps extends StyledProp {}

const Logo = ({ className }: LogoProps) => {
  const { isDark } = useThemeMode();

  const colorLetters = isDark ? '#fff' : '#000';

  return (
    <svg
      className={className}
      width='201'
      height='68'
      viewBox='0 0 201 68'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.9513 67.8358C52.6352 67.8358 67.7815 52.6896 67.7815 34.0058C67.7815 15.322 52.6352 0.175781 33.9513 0.175781C15.2674 0.175781 0.121094 15.322 0.121094 34.0058C0.121094 52.6896 15.2674 67.8358 33.9513 67.8358Z'
        fill='#FFBC00'
      />
      <path
        d='M25.5994 20.9594L35.2863 39.4467C35.2863 39.4467 46.1128 17.1607 47.569 12.7288C41.702 9.03558 34.5265 7.51607 27.3511 9.47876C14.0976 12.9398 6.05683 26.8475 9.53904 40.312C10.4043 43.7942 12.156 47.0442 14.3297 49.8722L25.5994 20.9383V20.9594Z'
        fill='#0D2772'
      />
      <path
        d='M58.4128 27.5365C57.3364 23.4001 55.3737 19.7069 52.5458 16.8789C51.2373 20.1289 35.4513 50.6456 35.4513 50.6456C35.4513 50.6456 26.0387 33.6145 25.8277 34.0366C25.6167 34.4587 25.6167 34.6908 25.3845 35.1129L18.8633 54.4443C24.7303 58.7918 32.56 60.5223 40.1575 58.3486C53.8542 54.8664 61.895 40.9588 58.4128 27.4943V27.5365V27.5365Z'
        fill='#0D2772'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.0993 62.7205L25.8345 34.002L35.4581 52.7003L57.7715 9.95468C55.678 7.87954 53.3148 6.07608 50.7391 4.60156L35.8802 38.054L25.5601 18.8914L9.26172 57.1048C11.2811 59.2605 13.5795 61.1516 16.0993 62.7205Z'
        fill='#ffffff'
      />
      <path
        d='M107.972 48.8044V19.2031H103.744V42.0384L88.9852 19.2031H84.6719V48.8044H88.9007V25.8846L103.659 48.8044H107.972Z'
        fill={colorLetters}
      />
      <path
        d='M127.552 48.8044H131.188V27.6606H127.213V39.2474C127.213 41.2983 126.748 42.863 125.839 43.899C124.93 44.9351 123.682 45.4637 122.054 45.4637C120.426 45.4637 119.2 44.9562 118.396 43.9413C117.593 42.9264 117.191 41.4463 117.191 39.5011V27.6606H113.174V40.0086C113.174 42.0172 113.512 43.6876 114.168 45.0196C114.823 46.3517 115.775 47.3666 116.98 48.0643C118.185 48.7621 119.623 49.1004 121.251 49.1004C122.519 49.1004 123.661 48.8678 124.697 48.3815C125.733 47.8952 126.579 47.2186 127.256 46.3094L127.552 48.8044Z'
        fill={colorLetters}
      />
      <path
        d='M137.743 27.6607V21.7404H141.76V27.6607H147.046V31.2128H141.76V41.6155C141.76 42.9053 142.014 43.8356 142.543 44.3642C143.071 44.8928 143.727 45.21 144.53 45.2734C145.334 45.3368 146.179 45.3157 147.046 45.21V48.6352C145.883 48.889 144.763 48.9735 143.642 48.8678C142.522 48.7621 141.528 48.445 140.64 47.9164C139.752 47.3878 139.054 46.6055 138.525 45.5694C137.997 44.5334 137.743 43.2225 137.743 41.6155V31.2128H134.698V27.6607H137.743Z'
        fill={colorLetters}
      />
      <path
        d='M154.278 27.6606H150.641V48.8043H154.616V37.8519C154.616 36.5832 154.827 35.5049 155.25 34.5957C155.673 33.6865 156.223 32.9677 156.921 32.4179C157.618 31.8682 158.401 31.5087 159.268 31.3396C160.134 31.1704 161.044 31.1916 161.974 31.4242V27.6606C160.98 27.428 160.029 27.428 159.12 27.6183C158.21 27.8086 157.365 28.168 156.582 28.6543C155.8 29.1406 155.123 29.7538 154.531 30.4939L154.278 27.6606Z'
        fill={colorLetters}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M173.984 49.1003C171.975 49.1003 170.178 48.6563 168.592 47.7683C167.006 46.8803 165.759 45.6328 164.85 44.0047C163.94 42.3766 163.496 40.4737 163.496 38.2747C163.496 36.0758 163.961 34.1094 164.892 32.4814C165.822 30.8533 167.091 29.5847 168.698 28.6966C170.305 27.8086 172.102 27.3646 174.111 27.3646C176.119 27.3646 177.916 27.8086 179.545 28.6966C181.173 29.5847 182.441 30.8321 183.372 32.4602C184.302 34.0883 184.767 35.9912 184.767 38.1902C184.767 40.3891 184.302 42.3555 183.35 43.9836C182.399 45.6116 181.109 46.8803 179.481 47.7683C177.853 48.6563 176.013 49.1003 173.984 49.1003ZM173.941 45.4636C175.062 45.4636 176.119 45.2099 177.113 44.6813C178.107 44.1527 178.91 43.3704 179.545 42.2921C180.179 41.2137 180.496 39.8605 180.496 38.1902C180.496 36.5198 180.2 35.2089 179.587 34.1517C178.974 33.0945 178.191 32.3122 177.198 31.7836C176.204 31.255 175.147 31.0013 174.026 31.0013C172.905 31.0013 171.912 31.255 170.96 31.7836C170.009 32.3122 169.247 33.0945 168.655 34.1729C168.063 35.2512 167.767 36.6044 167.767 38.2747C167.767 39.9451 168.063 41.256 168.634 42.3132C169.205 43.3704 169.966 44.1527 170.897 44.6813C171.827 45.2099 172.842 45.4636 173.941 45.4636Z'
        fill={colorLetters}
      />
      <path
        d='M192.4 27.6606H188.763V48.8043H192.738V37.8519C192.738 36.5832 192.95 35.5049 193.373 34.5957C193.796 33.6865 194.345 32.9677 195.043 32.4179C195.741 31.8682 196.523 31.5087 197.39 31.3396C198.257 31.1704 199.166 31.1916 200.096 31.4242V27.6606C199.103 27.428 198.151 27.428 197.242 27.6183C196.333 27.8086 195.487 28.168 194.705 28.6543C193.922 29.1406 193.246 29.7538 192.654 30.4939L192.4 27.6606Z'
        fill={colorLetters}
      />
    </svg>
  );
};

export default Logo;
